"use client";

import * as React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { useSession } from "@repo/api-client";

export function WorkspaceSwitcher({
  label = "Branch",
  variant: _variant = "default",
}: {
  label?: string;
  variant?: "default" | "sidebar";
}) {
  const { workspaces, workspaceId, switchWorkspace } = useSession();
  const [busy, setBusy] = React.useState(false);
  const current =
    workspaces.find((workspace) => workspace.id === workspaceId) ??
    workspaces[0] ??
    null;

  if (!current) return null;
  if (workspaces.length <= 1) {
    return (
      <div className="flex w-full items-center justify-between gap-3 px-2 py-2">
        <span className="shrink-0 text-xs text-tertiary">{label}</span>
        <span className="min-w-0 truncate text-right text-[13px] font-medium text-foreground">
          {current.name}
        </span>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between gap-3 px-2 py-2">
      <span className="shrink-0 text-xs text-tertiary">{label}</span>
      <Select
        value={workspaceId ?? current.id}
        onValueChange={(id) => {
          setBusy(true);
          void switchWorkspace(id).finally(() => setBusy(false));
        }}
      >
        <SelectTrigger
          size="compact"
          className="min-w-0 max-w-[70%] font-medium"
          disabled={busy}
          aria-label={label}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {workspaces.map((workspace) => (
            <SelectItem key={workspace.id} value={workspace.id}>
              {workspace.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
